"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const Environment_1 = require("../Environment");
const handleError_1 = require("../Environment/handleError");
const graphql_tag_1 = require("graphql-tag");
const _1 = require(".");
exports.fetchDeviceLists = () => (dispatch) => {
    const query = graphql_tag_1.default `
            query FetchDeviceLists {
                deviceLists(first: 1000, orderBy: { field: CREATED_AT, direction: DESC }) {
                    nodes {
                        id
                        name
                        size
                        createdAt
                    }
                }
            }
        `;
    const request = { query };
    return Environment_1.default(request).then(({ data, errors }) => {
        if (errors) {
            return handleError_1.default('FETCH_DEVICE_LISTS_FAILURE', dispatch, errors[0].message);
        }
        return dispatch({
            type: 'FETCH_DEVICE_LISTS_SUCCESS',
            deviceLists: data.deviceLists.nodes,
        });
    }, ({ result }) => handleError_1.default('FETCH_DEVICE_LISTS_FAILURE', dispatch, result.errors[0].message));
};
exports.uploadDeviceList = (file) => (dispatch) => {
    const query = graphql_tag_1.default `
            mutation DeviceListUpload($automated: Boolean!, $name: String!, $file: Upload!) {
                deviceListCreate(name: $name, file: $file, automated: $automated) {
                    id
                    name
                    size
                    createdAt
                }
            }
        `;
    const request = {
        query,
        variables: {
            automated: false,
            name: file.name,
            file,
        },
    };
    dispatch({ type: 'DEVICE_LIST_UPLOAD_REQUEST' });
    return Environment_1.default(request).then(({ data, errors }) => {
        if (errors) {
            return handleError_1.default('DEVICE_LIST_UPLOAD_FAILURE', dispatch, errors[0].message);
        }
        const { id, name, size, createdAt } = data.deviceListCreate;
        dispatch(_1.updateSegmentDeviceList(id, name, size, createdAt));
        dispatch({
            type: 'DEVICE_LIST_UPLOAD_SUCCESS',
            deviceList: data.deviceListCreate,
        });
        return data.deviceListCreate;
    }, ({ result }) => handleError_1.default('DEVICE_LIST_UPLOAD_FAILURE', dispatch, result.errors[0].message));
};
